import StopIconCell from './container';

export default StopIconCell;
